export default codeSnippet => {
	let result = undefined;
	if (codeSnippet) {
		try {
			result = new Function(`return ${codeSnippet}`)();
		} catch (err) {
			result = undefined;
		}
	}
	return result;
}
